import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { Store } from "@ngrx/store";
import { getNavigationSelector } from "@store/navigation/navigation.selector";
import { fetchNavigation } from "@store/navigation/navigation.actions";
import { NavigationState } from "@models/index";

import { toggleSidebar } from '@store/sidebar/sidebar.actions';
import { INavItem } from '@interfaces/iNavItem';
import { map } from 'rxjs/operators';
import { Countries } from "@interfaces/countries";

@Injectable({
  providedIn: "root",
})
export class UiService {
  backendUrl = environment.backendUrl;

  constructor(
    private store: Store<{ navigation: NavigationState }>,
    private http: HttpClient
  ) {}

  fetchNavigation() {
    this.store.dispatch(fetchNavigation());
  }

  getNavigation() {
    return this.http.get<INavItem[]>('/assets/navigation/navigation.json')
    .pipe(map((list) => list.filter((nav) => nav.url !== '/downline')));

  }

  getCountries() {
    return this.http.get<Countries[]>('/assets/countries/countriesCode.json')
  }

  getNavigationSelector(): Observable<NavigationState> {
    return this.store.select(getNavigationSelector);
  }

  toggleSidebar() {
    return this.store.dispatch(toggleSidebar());
  }

  async uploadImage(formDate: FormData, resource: string) {
    return this.http
      .post(`${this.backendUrl}/uploads/upload/${resource}`, formDate)
      .toPromise();
  }
}
